/**
 * Syncs cart drawer + icon when third-party flows add to cart without theme `sections` HTML
 * (e.g. LDT compare, jQuery `$.post`, or POST `/cart/add` returning HTML).
 *
 * - Patches `fetch` and `XMLHttpRequest` (jQuery.ajax uses XHR).
 * - Refreshes on successful POST to cart add endpoints even when the response is not JSON.
 * - Fetches sections from `routes.cart_sections_render_path` so app proxy paths are not used.
 */
(function () {
  if (!window.fetch) return;

  var nativeFetch = window.fetch;
  var refreshTimer = null;

  function isCartAddPath(url) {
    if (url == null || url === '') return false;
    var s = String(url);
    try {
      if (/^https?:\/\//i.test(s)) s = new URL(s, window.location.origin).pathname;
    } catch (_e) {
      /* keep s */
    }
    return /\/cart\/add(\.|$|\?|\/)/.test(s);
  }

  function sectionsPayloadLooksPopulated(sec) {
    if (!sec || typeof sec !== 'object') return false;
    for (var k in sec) {
      if (!Object.prototype.hasOwnProperty.call(sec, k)) continue;
      var v = sec[k];
      if (typeof v === 'string' && v.trim() !== '') return true;
    }
    return false;
  }

  function getDrawerInnerFromSectionHtml(htmlString, selector) {
    if (!htmlString || typeof htmlString !== 'string') return '';
    try {
      var doc = new DOMParser().parseFromString(htmlString, 'text/html');
      var sel = selector || '#CartDrawer';
      var node =
        doc.querySelector(sel) ||
        (sel === '#CartDrawer'
          ? doc.querySelector('cart-drawer #CartDrawer')
          : sel === '.drawer__inner'
            ? doc.querySelector('#CartDrawer .drawer__inner') || doc.querySelector('cart-drawer .drawer__inner')
            : null);
      return node ? node.innerHTML : '';
    } catch (_e) {
      return '';
    }
  }

  function syncDrawerHostFromCart(cartDrawer, cart) {
    if (!cartDrawer || !cart) return;
    var raw = cart.item_count;
    var cnt = typeof raw !== 'undefined' && raw !== null ? Number(raw) : NaN;
    var n = Number.isFinite(cnt)
      ? cnt
      : Array.isArray(cart.items)
        ? cart.items.length
        : Array.isArray(cart.line_items)
          ? cart.line_items.length
          : 0;
    var empty = n === 0;
    cartDrawer.classList.toggle('is-empty', empty);
    var itemsHost = cartDrawer.querySelector('cart-drawer-items');
    if (itemsHost) itemsHost.classList.toggle('is-empty', empty);
  }

  function getBubbleInner(htmlString) {
    var doc = new DOMParser().parseFromString(htmlString, 'text/html');
    var node =
      doc.querySelector('.shopify-section') ||
      doc.querySelector('[id^="shopify-section"]') ||
      doc.body.firstElementChild;
    return node ? node.innerHTML : '';
  }

  function refreshDrawerAndBubble() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return Promise.resolve();

    var roots =
      window.routes &&
      typeof window.routes.cart_sections_render_path === 'string' &&
      window.routes.cart_sections_render_path
        ? window.routes.cart_sections_render_path
        : '/';
    var joinChar = roots.indexOf('?') >= 0 ? '&' : '?';
    var sectionUrl = roots + joinChar + 'sections=cart-drawer,cart-icon-bubble';

    return nativeFetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        syncDrawerHostFromCart(cartDrawer, cart);

        return nativeFetch(sectionUrl)
          .then(function (response) {
            return response.json();
          })
          .then(function (sections) {
            if (sections['cart-drawer']) {
              var drawerRoot = document.querySelector('#CartDrawer');
              var innerHtml = getDrawerInnerFromSectionHtml(sections['cart-drawer'], '#CartDrawer');
              if (drawerRoot && innerHtml) drawerRoot.innerHTML = innerHtml;
            }

            if (sections['cart-icon-bubble']) {
              var bubbleEl = document.getElementById('cart-icon-bubble');
              var bubbleInner = getBubbleInner(sections['cart-icon-bubble']);
              if (bubbleEl && bubbleInner) bubbleEl.innerHTML = bubbleInner;
            }

            syncDrawerHostFromCart(cartDrawer, cart);

            setTimeout(function () {
              var overlay = document.querySelector('#CartDrawer-Overlay');
              if (overlay && typeof cartDrawer.close === 'function') {
                overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
              }
            }, 0);

            if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-add-bridge',
                cartData: cart,
              });
            }
          });
      })
      .catch(function (err) {
        console.warn('[cart-add-bridge] drawer refresh failed', err);
      });
  }

  function scheduleDrawerRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      refreshDrawerAndBubble();
    }, 50);
  }

  window.fetch = function fetchWithCartBridge() {
    var fetchArgs = arguments;
    return nativeFetch.apply(this, fetchArgs).then(function (response) {
      try {
        var req = fetchArgs[0];
        var init = fetchArgs[1] || {};

        var url = '';
        if (typeof req === 'string') url = req;
        else if (req && typeof req.url === 'string') url = req.url;

        var method = '';
        if (req && typeof req.method === 'string') method = req.method;
        if (!method && init && typeof init.method === 'string') method = init.method;
        method = String(method || 'GET').toUpperCase();

        if (!url || !isCartAddPath(url) || method !== 'POST') return response;

        if (!response.ok) return response;

        var ctype = '';
        try {
          ctype = (response.headers.get('content-type') || '').toLowerCase();
        } catch (_e) {
          ctype = '';
        }

        if (ctype.indexOf('json') !== -1) {
          return response
            .clone()
            .json()
            .then(function (payload) {
              if (!payload || payload.status === 422) return response;
              if (sectionsPayloadLooksPopulated(payload.sections)) return response;
              scheduleDrawerRefresh();
              return response;
            })
            .catch(function () {
              scheduleDrawerRefresh();
              return response;
            });
        }

        /** HTML / redirect body from `/cart/add` or other non-JSON success responses */
        scheduleDrawerRefresh();
        return response;
      } catch (_err) {
        return response;
      }
    });
  };

  /** jQuery `$.ajax` / `$.post` and some app bundles use XHR, not `fetch`. */
  if (window.XMLHttpRequest && XMLHttpRequest.prototype.send) {
    var nativeOpen = XMLHttpRequest.prototype.open;
    var nativeSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cabMethod = method;
      this.__cabUrl = url;
      return nativeOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      var method = String(xhr.__cabMethod || '').toUpperCase();
      var url = xhr.__cabUrl;

      function onDone() {
        if (method !== 'POST') return;
        if (!isCartAddPath(url)) return;
        if (xhr.status < 200 || xhr.status >= 300) return;
        scheduleDrawerRefresh();
      }

      xhr.addEventListener('loadend', onDone);
      return nativeSend.apply(this, arguments);
    };
  }
})();
